import { MapPlusIcon } from './MapPlusIcon';

/**
 * author: Peter Noble
 * id 3D7A000E-3E94-4B9B-8CAB-2F6923D425B7
 * name map-plus
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-plus.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const MapAddIcon = MapPlusIcon;
export default MapAddIcon